import { render, staticRenderFns } from "./InjuryReportView.vue?vue&type=template&id=22c03758&"
import script from "./InjuryReportView.vue?vue&type=script&lang=ts&"
export * from "./InjuryReportView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports